import { DeleteOutlined, HomeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

export default function DataDeletionPage() {
  const nav = useNavigate();

  return (
    <div className="flex flex-col bg-[#19181c] text-white px-6 w-full py-16">
      <div className="max-w-4xl mx-auto h-full">
        <div className="mb-12">
          <h1 className="text-5xl font-bold mb-4 text-[#F6B34B]">
            Account & Data Deletion
          </h1>

          <p className="text-white/70 text-sm">
            Last updated: May 12, 2026
          </p>
        </div>

        <div className="space-y-10 text-white/90 leading-8">
          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Requesting Account Deletion
            </h2>

            <p>
              Users who wish to delete their account and associated application
              data can do so directly within the application settings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              How to Delete Your Account
            </h2>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
              <ol className="list-decimal pl-6 space-y-4 text-white/85">
                <li>Log in to your account</li>

                <li>
                  Navigate to your account or profile settings section
                </li>

                <li>Select the “Remove Account” option</li>

                <li>Follow the on-screen confirmation steps</li>

                <li>
                  Confirm the deletion request to permanently remove your
                  account and associated data
                </li>
              </ol>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              What Data Is Deleted
            </h2>

            <p className="mb-4">
              When an account deletion request is completed, the following data
              may be removed from our systems:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-white/80">
              <li>User account information</li>
              <li>Stored Facebook access credentials and tokens</li>
              <li>Associated publishing preferences and settings</li>
              <li>Operational account data related to the user</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Retained Information
            </h2>

            <p>
              Certain limited operational, security, auditing, or legal
              compliance records may be retained where required for legitimate
              business, security, or legal purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Need Assistance?
            </h2>

            <p>
              If you are unable to access your account or require assistance
              completing the deletion process, please contact your organization
              administrator.
            </p>

            <div className="flex justify-end gap-4 mt-6">
              <Button
                type="primary"
                danger
                size="large"
                icon={<DeleteOutlined />}
                onClick={() => nav("/login")}
              >
                REMOVE ACCOUNT
              </Button>

              <Button
                type="default"
                size="large"
                onClick={() => nav("/")}
              >
                <HomeOutlined style={{ marginRight: "0.5rem" }} />
                HOME
              </Button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}